import React from 'react';
import { Typography, Tooltip } from '@hpi-sox/hpstellar-core/visId';

import './sustainability-logo.less';
import Icon from '../../category-landing-page/components/icon-mapper';

export default ({
    sustainabilityAttribute,
    size = 'large',
    text = 'Sustainability features',
    style,
    enableTooltip = false,
    toolTipProps = {},
    iconSize = 'l',
}) => {
    if (!sustainabilityAttribute || sustainabilityAttribute.toLowerCase() === 'none') {
        return null;
    }

    return (
        <div className={`sustainability-badge ${size}`} style={style}>
            <Icon size={iconSize} name="sustainability" />
            <Typography variant={size === 'large' ? 'caption' : 'footnotes'} tag="span" responsive>
                {text}
            </Typography>
            {enableTooltip && (
                <Tooltip
                    className="sustainability-tooltip-button"
                    content={<div className="sustainability-tooltip">{sustainabilityAttribute}</div>}
                    title={text}
                    {...toolTipProps}
                    triggerButtonProps={{ 'aria-label': `Tooltip for ${text}` }}
                />
            )}
        </div>
    );
};
